<template>
	<div class="validate-error pa-2 ma-2 pa-sm-4 ma-sm-4" v-if="errors.length">
		<v-row no-gutters align="center" class="mb-1">
			<v-col cols="1" class="text-center">
				<v-icon color="red" class="shrink"> mdi-alert-circle-outline </v-icon>
			</v-col>
			<v-col cols="11" class="pl-sm-0 pl-2"> 入力に誤りがあります </v-col>
		</v-row>

		<v-row v-for="(error, i) in errors" :key="`errors-${i}`" no-gutters align="center">
			<v-col cols="1" class="pl-sm-0 pl-2"></v-col>
			<v-col cols="11" class="pl-sm-0 pl-2"> ※{{ error }} </v-col>
		</v-row>
	</div>
</template>

<script>
export default {
	props: {
		errors: {
			type: Array,
			required: true,
			default: null,
		},
	},
	data() {
		return {}
	},
}
</script>
